export const footerContent = `nicolasz.dev - ${new Date().getFullYear()} | 
Developed by Nicolas Zwierzykowski`;
